export default __webpack_public_path__ + "card3.png";